<div class="limit-warning">
  <div class="limit-warning__header">
    <h2 id="deactivationWarningTitle" class="limit-warning__title">
      Limit reached
    </h2>
    <div class="limit-warning__close">
      <span
        nz-icon
        nzType="close"
        nzTheme="outline"
        (click)="onCloseModal()"
      ></span>
    </div>
  </div>

  <div class="limit-warning__body">
    <div class="limit-warning__notice">
      You can have up to <span>{{ data.limit }} Source Schain files</span> per
      side (SSP and DSP). To add a new file, please delete one of the existing
      files.
    </div>
  </div>

  <div class="limit-warning__footer">
    <button
      nz-button
      type="button"
      nzType="primary"
      class="limit-warning__btn limit-warning__btn--secondary"
      (click)="onCloseModal()"
    >
      Close
    </button>
  </div>
</div>
